import { Box } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import AccessibilityIcon from "../../../assets/SVG/accessibilityIcon";
import AllergyIcon from "../../../assets/SVG/allergyIcon";
import Bloodtype from "../../../assets/SVG/bloodType";
import MaskIcon from "../../../assets/SVG/maskIcon";
import { LabelInformation } from "./generalInformation";

export default function SpecializedInformation({
  bloodType,
  abilities,
  diseases,
  allergies,
}) {
  const [BloodType, setBloodType] = useState("");
  useEffect(() => {
    if (bloodType) {
      if (bloodType === "A_PLUS") setBloodType("A+");
      if (bloodType === "A_MINUS") setBloodType("A-");
      if (bloodType === "B_PLUS") setBloodType("B+");
      if (bloodType === "B_MINUS") setBloodType("B-");
      if (bloodType === "AB_MINUS") setBloodType("AB-");
      if (bloodType === "AB_PLUS") setBloodType("AB+");
      if (bloodType === "O_PLUS") setBloodType("O+");
      if (bloodType === "O_MINUS") setBloodType("O-");
    }
  }, []);

  return (
    <Box sx={{ margin: "auto" }} width="fit-content">
      <LabelInformation
        label="مهارت ها"
        value={abilities ? abilities : "مهارتی ثبت نشده است"}
      >
        <AccessibilityIcon />
      </LabelInformation>
      <LabelInformation
        label="بیماری ها"
        value={diseases ? diseases : "بیماری ثبت نشده است"}
      >
        <MaskIcon />
      </LabelInformation>
      <LabelInformation
        label="حساسیت ها"
        value={allergies ? allergies : "حساسیتی ثبت نشده است"}
      >
        <AllergyIcon />
      </LabelInformation>
      <LabelInformation label="گروه خونی" value={`${BloodType}`}>
        <Bloodtype />
      </LabelInformation>
    </Box>
  );
}
